import React from 'react';

interface UrlMetadata {
  url: string;
  title?: string;
  description?: string;
  favicon?: string;
  image?: string;
}

interface UrlPreviewProps {
  url: string;
  metadata: UrlMetadata;
}

export function UrlPreview({ url, metadata }: UrlPreviewProps) {
  const getFriendlyUrlText = (url: string): string => {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname.replace(/^www\./, '');
    } catch {
      return url;
    }
  };

  return (
    <a 
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="block p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors w-full my-2"
    >
      <div className="flex flex-row gap-3 max-w-full">
        {metadata.image && (
          <div className="w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden bg-gray-200">
            <img 
              src={metadata.image}
              alt={metadata.title || "Link preview"}
              className="w-full h-full object-cover"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.style.display = 'none';
              }}
            />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1 min-w-0">
            {metadata.favicon && (
              <img 
                src={metadata.favicon}
                alt=""
                className="w-4 h-4 flex-shrink-0"
                onError={(e) => {
                  const img = e.target as HTMLImageElement;
                  img.style.display = 'none';
                }}
              />
            )}
            <p className="text-blue-600 font-medium text-sm break-words overflow-hidden">
              {metadata.title}
            </p>
          </div>
          {metadata.description && (
            <p className="text-gray-500 text-sm break-words overflow-hidden">
              {metadata.description}
            </p>
          )}
          <p className="text-gray-400 text-xs mt-1 break-all">
            {getFriendlyUrlText(url)}
          </p>
        </div>
      </div>
    </a>
  );
}